import type { DashboardCompany } from "../lib/api";

interface Props {
  companies: DashboardCompany[];
  activeId: number;
  onSelect: (id: number) => void;
}

export function TabBar({ companies, activeId, onSelect }: Props) {
  return (
    <nav className="flex items-end gap-10 border-b border-border mb-12 overflow-x-auto">
      {companies.map((company, idx) => {
        const active = company.id === activeId;
        return (
          <button
            key={company.id}
            onClick={() => onSelect(company.id)}
            className={`
              group relative pb-4 transition-colors duration-150 whitespace-nowrap
              ${active ? "text-ink" : "text-muted hover:text-ink"}
            `}
          >
            <div className="flex items-baseline gap-3">
              <span className="font-mono text-[10px] tracking-editorial text-faint">
                {String(idx + 1).padStart(2, "0")}
              </span>
              <span className="font-display text-2xl tracking-tight font-medium">
                {company.displayName}
              </span>
            </div>
            <div
              className={`
                absolute bottom-[-1px] left-0 right-0 h-px
                bg-ink origin-left transition-transform duration-300
                ${active ? "scale-x-100" : "scale-x-0"}
              `}
            />
          </button>
        );
      })}
    </nav>
  );
}
